<template>
  <div class="product-box">
    <div class="box-wraper">
      <div class="box-single-prod-photo">
        <a :href="productCardURL">
          <img class="photo" :src="prodPhoto" :alt="'Zdjęcie produktu: ' + product.prodSymbol" />
        </a>
        <div class="flags">
          <span v-if="product.newsFlag == 1" class="flag flag-news">Nowość</span>
        </div>
      </div>
      <div class="box-single-prod">
        <div class="box-single-prod-info">
          <!-- <span class="box-prod-line">{{ prodLine }}{{ "\xa0" }}</span> -->
          <span class="box-prod-name">{{ product.prodName }}</span>
          <span class="box-prod-symbol">
            <a :href="productCardURL">{{ product.prodSymbol }}</a>
          </span>
          
          <ul
            v-if="
              product.attrFeaturedDataList &&                              
                product.attrFeaturedDataList.attributeData.length
            "
            class="box-prod-functions-list"
          >
            <template v-for="attribute in product.attrFeaturedDataList.attributeData">
              <li
                v-if="attribute != null"
                v-bind:key="
                  'highlighted_attribute_' + product.prodID + '_' + attribute.attrID
                "
              >
                {{ highlightedAttribute(attribute) }}
              </li>
            </template>
          </ul>
          
        </div>
        <a :data-ean="product.prodEAN" class="cc-fi-button buy-online" href="#">
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            width="34px"
            height="31px"
            viewBox="196.042 229.698 34 31"
            enable-background="new 196.042 229.698 34 31"
            xml:space="preserve"
          >
            <g transform="translate(0,-288.53332)">
              <path
                fill="#fff"
                d="M196.741,518.231c-0.932-0.004-0.932,1.419,0,1.414h3.511c0.895,0,1.684,0.583,1.962,1.456l4.743,14.853
		l-2.266,1.609c-0.614,0.437-1.034,1.163-1.034,2.017v0.135c0,1.353,1.095,2.465,2.425,2.465h23.204
		c1.007,0.092,1.007-1.495,0-1.403h-23.204c-0.582,0-1.045-0.471-1.045-1.062v-0.135c0-0.293,0.264-0.73,0.452-0.864l2.558-1.819
		h16.634c0.896,0,1.689-0.588,1.965-1.456l3.243-10.214c0.427-1.344-0.584-2.765-1.973-2.765h-20.105
		c-1.007-0.091-1.007,1.496,0,1.403h20.105c0.483,0,0.803,0.449,0.652,0.925l-0.602,1.893h-17.446
		c-0.927,0.048-0.854,1.463,0.073,1.414h16.924l-0.896,2.82h-13.326c-0.852,0.109-0.787,1.384,0.07,1.403h12.813l-0.853,2.683
		c-0.094,0.294-0.346,0.49-0.645,0.49h-16.42l-4.726-14.831c-0.462-1.445-1.792-2.432-3.284-2.432L196.741,518.231z"
              />
              <path
                fill="#fff"
                d="M209.9,543.595c-1.523,0-2.773,1.271-2.773,2.818s1.25,2.818,2.773,2.818c1.522,0,2.763-1.271,2.763-2.818
		C212.661,544.865,211.422,543.595,209.9,543.595L209.9,543.595z M209.9,544.998c0.773,0,1.381,0.628,1.381,1.415
		s-0.607,1.404-1.381,1.404c-0.774,0-1.392-0.617-1.392-1.404S209.126,544.998,209.9,544.998z"
              />
              <path
                fill="#fff"
                d="M223.752,543.595c-1.522,0-2.772,1.271-2.772,2.818s1.25,2.818,2.772,2.818s2.772-1.271,2.772-2.818
		S225.275,543.595,223.752,543.595z M223.752,544.998c0.773,0,1.392,0.628,1.392,1.415s-0.618,1.404-1.392,1.404
		s-1.381-0.617-1.381-1.404S222.979,544.998,223.752,544.998z"
              />
            </g>
          </svg>
          {{ i18n.buy_online }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import slug from "slug";

export default {
 props: ["product","i18n"],
  data() {
    return {
      buybox_active: false,
      buybox_shops: [],
      buybox_loading: false,
      isCompared: false,
    };
  },
  //   watch: {
  //     comparedCat(val) {
  //       if (val.toString() !== this.category_id.toString()) {
  //         this.isCompared = false;
  //       }
  //     },
  //   },
  computed: {
      pol() {
      return window.pageContentData.locale !== "en";
    },
    prodLine: function() {
      if (this.product.prodLineData) {
        return this.product.prodLineData.lineName;
      }
      return "";
    },
    prodPhoto: function() {
      return "http://amica.pl/produkt/zdjecie/" + this.product.prodID + "/320";
    },
    productCardURL: function() {
      const prodLineName = this.product.prodLineData
        ? this.product.prodLineData.lineName
        : "";
      const category = this.pol ? "produkty/produkt/" : "en/products/product/";

      return (
        this.baseUrl +
        category +
        this.product.prodID +
        "-" +
        slug(this.product.prodName, "_") +
        "-" +
        slug(prodLineName) +
        "-" +
        slug(this.product.prodSymbol, "_")
      );
    },
    baseUrl() {
      return window.pageContentData.base_URL;
    },
    // comparedCat() {
    //   return this.$store.getters.getCompareCat;
    // },
  },
  methods: {
    highlightedAttribute: function(attribute) {
      if (attribute.attrName && attribute.attrValue) {
        return attribute.attrName + " " + attribute.attrValue;
      } else if (attribute.attrValue) {
        return attribute.attrValue;
      }
    },
  },
  mounted() {
    if (this.compared_products && this.compared_products[this.category_id]) {
      this.isCompared = Object.keys(
        this.compared_products[this.category_id]
      ).includes(this.product.prodID.toString());
    }
  },
};
</script>


<style lang="scss" scoped>
.product-box {
  height: auto;
  .box-wraper {
    display: flex;    
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;

    .box-single-prod-photo {
      display: flex;
      max-width: 80%;
      position: relative;
      padding-left: 25px;
      padding-right: 25px;
      z-index: 22;
        @media screen and (min-width: 1700px) {
        max-width: 68%;
       }
      
      .photo {
        width: 100%;
        height: auto;
        @media screen and (max-width: 1400px) {
        width: 50%;
        }
      }
    }
    .box-single-prod {
      display: flex;
      flex-direction: column;
      font-size: 13px;
      background: #eaeaea;
      border-radius: 15px;
      padding-left: 25px;
      padding-right: 50px;
      padding-top: 65px;
      margin-top: -50px;
      width: 275px;
      .box-single-prod-info {
        display: flex;
        flex-direction: column;
        color: #000;        

        a {
          color: #000;
          text-decoration: none;
          width: 100%;
          font-size: 17px;
          font-weight: 900;
          line-height: 23px;
        }
      }
    }
    .buy-online {
      color: #fff;
      font-size: 14px;
      text-transform: uppercase;
      font-weight: 600;
      padding: 9px 20px 9px 35px;
      display: inline-block;
      width: fit-content;
      margin-top: 15px;
      margin-bottom: 35px;
      border-radius: 15px;
      padding-bottom: 34px;
      background-color: #e3182d;
      height: 40px;
      -webkit-box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.14);
      -moz-box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.14);
      box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.14);

      svg {
        top: -2px;
        left: -10px;
        position: relative;
        width: 20px;

        .a {
          fill: #000;
        }
      }

      &:hover {
        text-decoration: none;
        background-color: #d51326;
         color: #fde1e4;
      }
    }
  }

.actions-compare.actions-compare {
  margin-left: 0;

  span {
    &::before,
    &::after {
      transition: 0.2s;
    }
  }

  &:nth-child(2) {
    margin-left: auto;
    margin-right: 0;
  }

  &-highlight {
    color: #e3182d !important;
    font-weight: bold;
  }
}

.actions-compare-active {
  span {
    &::before,
    &::after {
      display: block;
      transform: rotate(45deg);
    }
  }
}

.box-prod-symbol {
  font-size: 1em;
  line-height: 26px;
  font-weight: 600;
}

.box-prod-functions-list {
    list-style-position: inside;
    padding-left: 0px;
}

.box-image {
  height: 230px;
  margin-bottom: 25px;
  text-align: center;
  width: 100%;

  img {
    margin: 0 auto;
    max-height: 100%;
    max-width: 100%;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }
}

.product-card__buttons {
  margin-top: auto;
}

.flags {
  position: absolute;
  top: 10px;
  right: -10px;
  z-index: 1;
    @media screen and (max-width: 1400px) {
         right: 25%;
        }
}
  .flag {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    border-radius: 99px;
    padding: 4px 12px;

    &.flag-news {
      color: #e41429;
      background: #fff;
      border: 1px #e41429 solid;
    }
  }
}
</style>
